(() => {
  async function initDescriptionPage(container) {
    if (container.dataset.descriptionPageInitialized) return;
    container.dataset.descriptionPageInitialized = 'true';
    const status = container.querySelector('[data-description-page-status]');
    const body = container.querySelector('[data-description-page-body]');
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 15000);
    try {
      const url = new URL(container.dataset.descriptionPageUrl, window.location.origin);
      if (url.origin !== window.location.origin) throw new Error('Description page must belong to this store.');
      // Preserve unpublished theme previews when requesting the selected page.
      const preview = new URLSearchParams(window.location.search);
      for (const key of ['preview_theme_id', 'preview_key']) {
        if (preview.has(key)) url.searchParams.set(key, preview.get(key));
      }
      const response = await fetch(url, { credentials: 'same-origin', signal: controller.signal });
      if (!response.ok) throw new Error(`Description page returned ${response.status}.`);
      if (new URL(response.url).pathname !== url.pathname) throw new Error('Description page redirected to another page.');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const main = doc.getElementById('MainContent');
      if (!main || (!main.textContent.trim() && !main.querySelector('img, video, picture'))) {
        throw new Error('Description page content is missing.');
      }
      // Keep rendered section styles; exclude the page shell and scripts that
      // would initialize another storefront inside the product description.
      main.querySelectorAll('script').forEach(script => script.remove());
      if (!container.isConnected) return;
      body.replaceChildren(...Array.from(main.childNodes, node => document.importNode(node, true)));
      status.remove();
    } catch (error) {
      if (container.isConnected) {
        status.textContent = 'The description could not be loaded. Please refresh the page to try again.';
        console.warn('Product description could not be loaded.', error);
      }
    } finally {
      clearTimeout(timeout);
      container.setAttribute('aria-busy', 'false');
    }
  }

  function initContent(root) {
    if (root.dataset.productContentInitialized) return;
    root.dataset.productContentInitialized = 'true';
    root.querySelectorAll('[data-description-page-content]').forEach(initDescriptionPage);
    const section = root.previousElementSibling;
    const tabs = [...(section?.querySelectorAll('[data-product-tab]') || [])];
    const panels = [...root.querySelectorAll('[data-product-panel]')];
    const activate = key => {
      const panel = panels.find(item => item.dataset.productPanel === key);
      if (!panel) return;
      tabs.forEach(tab => {
        const active = tab.dataset.productTab === key;
        tab.classList.toggle('active', active);
        tab.setAttribute('aria-current', active ? 'page' : 'false');
      });
      panels.forEach(item => item.classList.toggle('active', item === panel));
    };
    tabs.forEach(tab => tab.addEventListener('click', () => activate(tab.dataset.productTab)));
    root.querySelectorAll('.faq2 button').forEach(button => button.addEventListener('click', () => {
      const item = button.closest('.faq2');
      const open = item.classList.toggle('open');
      const marker = button.querySelector('span');
      if (marker) marker.textContent = open ? '−' : '+';
    }));
    const match = window.location.hash.match(/^#tab-(description|specifications|faq|reviews)$/);
    if (match) activate(match[1]);
  }
  function boot() { document.querySelectorAll('[data-product-content]').forEach(initContent); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
